import { SCREEN_ROUTES, ANALYTICS_MISC } from '~/constants/analytics'

function getScreenTypeByRoute(route: string): string {
  const results = Object.entries(SCREEN_ROUTES)
    .find(([_, routes])=> routes.some(r => route.match(r)))

  if (results) {
    const [ routeType ] = results
    return routeType
  }

  return ANALYTICS_MISC.UNKNOWN_TYPE
}

export default getScreenTypeByRoute
